import { deleteJourney } from "@/modules/lead-page/api/lead-page.v2.api";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { useContext } from "react";
import { useMutation } from '@tanstack/react-query';

const useDeleteLead = () => {
  const { lead } = useContext(LeadPageContext);
  const journeyUId = lead?.data?.lead?.journey_uid;

  const {
    mutate: deleteJourneyMutation,
    isLoading: isLoadingDeleteLead,
    isError,
    isSuccess,
  } = useMutation({
    mutationFn: ({ journeyUId }: { journeyUId: string | undefined }) =>
      deleteJourney(journeyUId),
  });

  const handleDeleteLeadLead = () => {
    deleteJourneyMutation({ journeyUId });
  };
  return {
    handleDeleteLeadLead,
    isLoadingDeleteLead,
    isError,
    isSuccess,
  };
};

export default useDeleteLead;
